/*
 * COPYRIGHT MOTOROLA SOLUTIONS, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Injectable, isDevMode } from '@angular/core';
import { PendoService } from './pendo.service';
import { PendoEventType, PendoEventPayloadMap } from './models/pendo-events.types';

@Injectable({
    providedIn: 'root'
})
export class PendoAnalyticsService {
    constructor(
        private pendoService: PendoService
    ) {}

    /**
     * Track a Pendo analytics event with type-safe payload.
     * Note: application and environment are automatically included via visitor/account
     * metadata set during Pendo initialization - no need to add them here.
     *
     * @param event - The event type from PendoEventType enum
     * @param payload - Type-safe payload matching the event type
     */
    public track<E extends PendoEventType>(event: E, payload: PendoEventPayloadMap[E]): void {
        const eventData = {
            ...payload,
            timestamp: new Date().toISOString()
        };

        if (isDevMode()) {
            console.debug(`[Pendo] Tracking event: "${event}"`, eventData);
        }

        if (this.pendoService.pendo && typeof this.pendoService.pendo.track === 'function') {
            this.pendoService.pendo.track(event, eventData);
        } else {
            console.warn(`[Pendo] SDK not available. Event "${event}" was not sent.`);
        }
    }
}
